module.exports = __webpack_public_path__ + "assets/img/services5.61e41d09.svg";